export enum ScanSequencesTabType {
  SCAN_SEQUENCE_INFO = 'scan-sequence-info',
  SCANNING_PLANS = 'scanning-plans',
}
